import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PostAssessmentSummaryFormFields {

    public assessment: FormField
    public project: FormField

    constructor() {

        this.assessment = new FormField(
          'assessment',
          'Assessment',
          'assessment',
          FormFieldType.pushedSelectionList,
          true,
        )
        this.project = new FormField(
          'project',
          'Project',
          'project',
          FormFieldType.pushedSelectionList,
          true,
        )

    }
}

const fields = new PostAssessmentSummaryFormFields()

export const postAssessmentSummaryFormFieldOptions: {[key: string]: FormField} = {
  assessment: fields.assessment,
  project: fields.project,
};